import { selectLocations } from "../state/selectors";
import { getState } from "../state/store";
import locationUtil from "./locationUtil";

const formatHardware = (hardwares) => {
  return hardwares.map((hardware) => {
    const { hubId, locationId = null, market = null } = hardware;

    return { hubId, locationId, market };
  });
};

const formatMercuryHardware = (hardwares) => {
  return hardwares.map((hardware) => {
    const { routerId, locationId = null, market = null } = hardware;

    return { hubId: routerId, routerId, locationId, market };
  });
};

const getHardwareIds = (hardware) => {
  return hardware?.map((el) => el?.hubId) ?? [];
};

const getLocationHardwareData = (hardware) => {
  const locations = selectLocations()(getState());
  const locationsList = locationUtil.formatLocations(locations);

  if (!hardware || !locationsList) {
    return null;
  }

  const locationHardwareData = locationsList.map((location) => {
    const locationId = location.id;
    const locationHardware = hardware
      ?.filter((el) => el.locationId === locationId)
      ?.map((el) => el.hubId);

    return {
      locationId,
      locationName: location?.locationName,
      market: location?.market,
      hardware: locationHardware
    };
  });

  return locationHardwareData;
};

const hardwareUtils = {
  formatHardware,
  formatMercuryHardware,
  getHardwareIds,
  getLocationHardwareData
};

export default hardwareUtils;
